'use client';

import React, {FC} from 'react';
import {ToastContainer as ToastContainerMain} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';

import styles from './NotificationsContainer.module.css';

export const TOAST_CONTAINER_ID = 'ToastContainer';

export const NotificationsContainer: FC = React.memo(function NotificationsContainer() {
	return (
		<ToastContainerMain
			containerId={TOAST_CONTAINER_ID}
			className={styles.toastContainer}
			data-testid={'toast-container'}
		/>
	);
});
